import { FETCH_CRASH_EVENT, FETCH_CRASH_EVENT_IS_ERROR, FETCH_CRASH_EVENT_IS_PENDING } from 'services/GameHosting/Crashes/types';
import * as apiActionTypes from 'utils/apiActionTypes';
import { parseError } from 'utils/functions';

const INITIAL_STATE = {
  crashes: [],
  fetchIsCompleted: false,
  fetchIsPending: false,
  fetchIsError: null,
};

const crashEventReducer = (
  state = {
    ...INITIAL_STATE,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case FETCH_CRASH_EVENT:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        crashes: action.data,
        fetchIsCompleted: true,
        fetchIsPending: false,
        fetchIsError: null,
      };
    case FETCH_CRASH_EVENT_IS_PENDING:
      return {
        ...state,
        fetchIsCompleted: false,
        fetchIsPending: true,
        fetchIsError: null,
      };
    case FETCH_CRASH_EVENT_IS_ERROR:
      return {
        ...state,
        fetchIsCompleted: true,
        fetchIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchIsError: parseError(action.error.message),
      };
    case apiActionTypes.CLEAN_ERROR:
      return {
        ...state,
        fetchIsError: null,
      };
    case 'RESET_CRASH_EVENT_REDUCER':
    case 'RESET_REDUCER':
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default crashEventReducer;
